import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Register } from './pages/Register';

import { Dashboard } from './pages/Dashboard';
import { CvUpload } from './pages/CvUpload';
import { Programme } from './pages/Programme';
import { PSQForm } from './pages/PSQForm';
import { TrainerDashboard } from './pages/TrainerDashboard';
import { TrainerClient } from './pages/TrainerClient';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminUsers } from './pages/admin/AdminUsers';
import { AdminEnrolments } from './pages/admin/AdminEnrolments';
import { AdminAnalytics } from './pages/admin/AdminAnalytics';
import { AdminTrainers } from './pages/admin/AdminTrainers';
import { AdminAuditLog } from './pages/admin/AdminAuditLog';
import { Apply } from './pages/Apply';
import { Programmes } from './pages/Programmes';
import { WhatWeDo } from './pages/WhatWeDo';
import { GetInvolved } from './pages/GetInvolved';
import { Policies } from './pages/Policies';
import { CvLite } from './pages/CvLite';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Settings } from './pages/Settings';
import { Community } from './pages/Community';
import { About } from './pages/About';
import { NotFound } from './pages/NotFound';
import { SeedbedDiscovery } from './pages/SeedbedDiscovery';
import { ProtectedRoute } from './components/ProtectedRoute';

export function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/about" element={<About />} />
      <Route path="/what-we-do" element={<WhatWeDo />} />
      <Route path="/programmes" element={<Programmes />} />
      <Route path="/get-involved" element={<GetInvolved />} />
      <Route path="/apply" element={<Apply />} />
      <Route path="/policies" element={<Policies />} />
      <Route path="/cv-lite" element={<CvLite />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/discovery" element={<SeedbedDiscovery />} />

      {/* Legacy redirect */}
      <Route path="/pricing" element={<Navigate to="/apply" replace />} />

      {/* Candidate */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/cv" element={<ProtectedRoute><CvUpload /></ProtectedRoute>} />
      <Route path="/programme/:id" element={<ProtectedRoute><Programme /></ProtectedRoute>} />
      <Route path="/programme/:id/psq/:sessionId" element={<ProtectedRoute><PSQForm /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />

      {/* Trainer */}
      <Route path="/trainer" element={<ProtectedRoute><TrainerDashboard /></ProtectedRoute>} />
      <Route path="/trainer/client/:id" element={<ProtectedRoute><TrainerClient /></ProtectedRoute>} />

      {/* Admin */}
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
      <Route path="/admin/enrolments" element={<ProtectedRoute><AdminEnrolments /></ProtectedRoute>} />
      <Route path="/admin/analytics" element={<ProtectedRoute><AdminAnalytics /></ProtectedRoute>} />
      <Route path="/admin/trainers" element={<ProtectedRoute><AdminTrainers /></ProtectedRoute>} />
      <Route path="/admin/audit-log" element={<ProtectedRoute><AdminAuditLog /></ProtectedRoute>} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
